import reduceReducers from 'reduce-reducers';

//Siblings reducers
import onsiteBookingPatientReducer from './onsite-booking-patient-reducer';
import onsiteBookingReducer from './onsite-booking-reducer';

export default reduceReducers(
  onsiteBookingReducer,
  onsiteBookingPatientReducer,
);
